import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { SidePanelManageCookies } from '../ManageCookies/SidePanelManageCookies';
import { useResponsiveness } from '../../responsiveness/useResponsiveness';
import { useSidePanelLayoutContext } from './SidePanelLayoutContext';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SidePanel = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isDesktop
  } = useResponsiveness();
  const {
    customLogo
  } = useSidePanelLayoutContext();
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    flexDirection: "column",
    gap: "800",
    blockSize: "100%",
    inlineSize: "30%",
    flexShrink: 0,
    backgroundColor: "fill-surface-recessed",
    overflowY: "auto",
    padding: "800"
  }, props, {
    children: [/*#__PURE__*/_jsxs(View, {
      children: [customLogo && /*#__PURE__*/_jsx(Image, {
        alt: customLogo.alt,
        blockSize: `${customLogo.height || 40}px`,
        responsive: false,
        src: customLogo.src,
        inlineSize: `${customLogo.width}px`
      }), !customLogo && /*#__PURE__*/_jsx(Logo, {
        name: "hubspot-wordmark",
        maxBlockSize: "30px"
      })]
    }), children, isDesktop && /*#__PURE__*/_jsx(SidePanelManageCookies, {})]
  }));
};
export const SidePanelContent = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  flexGrow: 1,
  children: children
});